import React, { useEffect } from 'react';
import { IoMdClose } from 'react-icons/io';
import { IconContext } from 'react-icons';
import { NavLink } from 'react-router-dom';

interface PopUpProps {
  openPopUp: boolean;
  closePopUp: () => void;
}

const PopUp: React.FC<PopUpProps> = ({ openPopUp, closePopUp }) => {
  const handleClosePopUp = (e: React.MouseEvent<HTMLDivElement>) => {
    // Fermer le popup seulement si l'utilisateur clique sur l'arrière-plan (pas sur le contenu)
    if ((e.target as HTMLDivElement).classList.contains('fixed')) {
      closePopUp();
    }
  };
  useEffect(() => {
    if (openPopUp) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [openPopUp]);
    // Fonction pour gérer le défilement fluide vers les ancres
    const handleSmoothScroll = (e: React.MouseEvent<HTMLAnchorElement>, to: string) => {
      // Si le lien contient une ancre
      if (to.includes('#') && to !== '#') {
        e.preventDefault();
        
        // Extraire l'ID de l'ancre
        const id = to.replace('/#', '');
        const element = document.getElementById(id);
        
        // Si l'élément existe, faire défiler jusqu'à lui
        if (element) {
          // Fermer le popup
          closePopUp();
          
          // Calculer la position de défilement
          const headerHeight = 80; // Ajustez selon la hauteur de votre en-tête
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerHeight;
          
          // Faire défiler
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      } else {
        // Pour les liens normaux, simplement fermer le popup
        closePopUp();
      }
    }


  if (!openPopUp) return null;

  const mainLinks = [
    { to: "/", label: "Accueil" },
    { to: "/#about", label: "À propos" },
    { to: "/#portfolio", label: "Portfolio" },
    { to: "/#contact", label: "Contactez-nous" }
  ];

  const portfolioLinks = [
    { to: '/Portrait', label: 'Portrait' },
    { to: '/Paysage', label: 'Paysage' },
    { to: '/Event', label: 'Événement' },
    { to: '/Tournage', label: 'Tournage' },
  ];

  return (
    <div
      id="ModelContainer"
      onClick={handleClosePopUp}
      className="fixed inset-0 z-50 bg-gray-900/80 backdrop-blur-sm"
    >
      <div className="fixed inset-y-0 left-0 w-full md:w-[80%] max-w-sm bg-[#0B0B0F]  text-white shadow-xl overflow-y-auto">
        {/* Header */}
        <div className="sticky top-0 z-10  bg-[#0B0B0F]  backdrop-blur-sm border-b border-gray-700">
          <div className="flex items-center justify-between p-4">
            <h2 className="text-xl font-serif">
              𝓨𝓸𝓱𝓪𝓷𝓥𝓲𝓼𝓲𝓸𝓷
            </h2>
            <button
              onClick={closePopUp}
              className="p-2 hover:bg-gray-700 rounded-full transition-colors text-white"
              aria-label="Fermer le menu"
            >
              <IconContext.Provider value={{ size: '1.5em' }}>
                <IoMdClose />
              </IconContext.Provider>
            </button>
          </div>
        </div>

        <div className="p-2">
          {/* Navigation principale */}
          <nav className="space-y-1">
            {mainLinks.map((link) => (
               <NavLink
               key={link.to}
               to={link.to}
               onClick={(e) => handleSmoothScroll(e, link.to)}
               className={({ isActive }) =>
                 `block px-4 py-3 text-lg transition-colors ${isActive
                   ? ' bg-[#16161e]  font-medium text-white'
                   : 'hover:bg-gray-700 text-gray-200 hover:text-white'}`
               }
             >
               {link.label}
             </NavLink>
            ))}
          </nav>
          
          {/* Sous-menu Portfolio */}
          <div className="mt-4  bg-[#0B0B0F]  rounded-lg p-2">
            <p className="px-4 py-2 text-sm text-gray-300 font-medium border-b border-gray-600 mb-2">Catégories Portfolio</p>
            {portfolioLinks.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                onClick={closePopUp}
                className={({ isActive }) =>
                  `block px-4 py-2 text-base transition-colors ${isActive
                    ? 'bg-gray-700 font-medium text-white'
                    : 'hover:bg-gray-700 text-gray-200 hover:text-white'}`
                }
              >
                {link.label}
              </NavLink>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PopUp;
